// A seleção dos atalhos vem de ces_metadata.campos[].showInCanvas.
import { editorFieldResource } from "./editorFieldResource";

export function reteInlineFields(stage, fieldOptions = {}) {
  const id = Number(stage.chatbot_estagio_id);
  const raw = stage.ces_metadata?.campos;
  if (!Array.isArray(raw)) return [];
  const fields = raw.flat();
  return fields
    .filter(
      (field, index) =>
        field?.showInCanvas === true &&
        fields.findIndex((item) => item?.bindText === field.bindText) === index
    )
    .map((field) => {
      const key = field.bindText;
      const resource = field.options?.length
        ? null
        : editorFieldResource(id, key);
      const dataState = {
        resource,
        status: fieldOptions.__dataStatus?.[resource] || null
      };
      if (field.showOn) return null;
      if (id === 25 && key === "atributos_customizaveis") {
        return {
          field,
          ...dataState,
          kind: "custom-attributes",
          options: fieldOptions.atributos_customizaveis || []
        };
      }
      const options =
        (field.options?.length ? field.options : null) ||
        fieldOptions[`${id}:${key}`] ||
        fieldOptions[key] ||
        field.options;
      if (["select", "multiSelect"].includes(field.type)) {
        if (!Array.isArray(options)) return null;
      } else if (
        !["text", "textArea", "textarea", "bool"].includes(field.type)
      ) {
        return null;
      }
      if (
        ["text", "textArea", "textarea"].includes(field.type) &&
        field.value != null &&
        !["string", "number"].includes(typeof field.value)
      )
        return null;
      return {
        field,
        stageId: id,
        ...dataState,
        options: options || [],
        readonly:
          key === "cfe_mensagem" &&
          fields.some(
            (item) =>
              item.bindText === "usar_meta_template" && item.value === true
          )
      };
    })
    .filter(Boolean);
}
